import * as Yup from 'yup';

// role / levelOfTraining are left nullable here —
// their "required when the selected parent has child options" rule is applied by
// the form via `useProfileRequirementSets` (see user-profile.component.js), which
// needs the fetched fields and can't live in this static schema.

export const CONTACT_SCHEMA = Yup.object().shape({
  email: Yup.string().email().nullable(),
  firstName: Yup.string().nullable().required('Required!'),
  lastName: Yup.string().nullable(),
  phone: Yup.string().nullable(),
  pager: Yup.string().nullable(),
  cisco: Yup.string().nullable(),
  department: Yup.string().nullable(),
  location: Yup.array().of(Yup.string()).nullable(),
});

export const USER_SCHEMA = Yup.object().shape({
  email: Yup.string().email('Please insert a valid email').required('Required!'),
  firstName: Yup.string().nullable(),
  lastName: Yup.string(),
  phone: Yup.string().nullable(),
  pager: Yup.string().nullable(),
  cisco: Yup.string().nullable(),
  profession: Yup.string(),
  role: Yup.string().nullable(),
  levelOfTraining: Yup.string().nullable(),
  department: Yup.string().nullable(),
  rotation: Yup.string().nullable(),
  division: Yup.array().of(Yup.string()).nullable(),
  location: Yup.array().of(Yup.string()).nullable(),
  specialty: Yup.array().of(Yup.string()).nullable(),
  unit: Yup.array().of(Yup.string()).nullable(),
  title: Yup.string().nullable(),
});

export const MY_PROFILE_SCHEMA = Yup.object().shape({
  firstName: Yup.string().required('Required!'),
  lastName: Yup.string().required('Required!'),
  phone: Yup.string(),
  pager: Yup.string(),
  cisco: Yup.string(),
  profession: Yup.string().required('Required!'),
  language: Yup.string().required('Required!'),
  timezone: Yup.string().required('Required!'),
  role: Yup.string().nullable(),
  levelOfTraining: Yup.string().nullable(),
  department: Yup.string().required('Required!'),
  rotation: Yup.string().nullable(),
  division: Yup.array().of(Yup.string()).nullable(),
  location: Yup.array().of(Yup.string()).nullable(),
  specialty: Yup.array().of(Yup.string()).nullable(),
  unit: Yup.array().of(Yup.string()).nullable(),
  title: Yup.string().nullable(),
});
